<template>
  <div>
    <b-overlay
      id="overlay-background"
      :show="loader"
      variant="dark"
      opacity="0.85"
      blur="2px"
      rounded="sm"
      spinner-variant="primary"
      spinner-medium
    >
      <!-- Table Container Card -->
      <b-card
        no-body
        class="mb-0"
      >
        <div class="m-2">
          <b-row>
            <b-col
              cols="12"
              md="6"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label>{{ $t('DEBTIA_SHOWING') }}</label>
              <v-select
                v-model="perPage"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :clearable="false"
                class="search_by_select per-page-selector d-inline-block mx-50"
                :options="perPageOptions"
              />
              <label>{{ $t('DEBTIA_ENTRIES') }}</label>
            </b-col>
            <b-col
              cols="12"
              md="6"
              class="query-input"
            >
              <div class="d-flex align-items-center justify-content-end">
                <b-form-input
                  v-model="searchQuery"
                  class="d-inline-block mr-1"
                  :placeholder="$t('DEBTIA_SEARCH')"
                />
                <b-button
                  variant="primary"
                  class="mr-1"
                  @click="getCaseGroups()"
                >
                  <span class="text-nowrap">{{ $t('DEBTIA_SEARCH') }}</span>
                </b-button>
                <b-button
                  v-if="$ability.can(constants.action.permissionAddCaseGroup, constants.resource.caseGroups)"
                  id="add-case-group-btn"
                  v-b-modal.create-case-modal
                  variant="primary"
                  @click="addCaseGroup(addCaseInput)"
                >
                  <span class="text-nowrap">{{ $t('DEBTIA_ADD_CASE_GROUP') }}</span>
                </b-button>
              </div>
            </b-col>
          </b-row>
        </div>
        <b-table
          ref="refUserListTable"
          class="position-relative"
          responsive
          selectable
          :fields="tableFields"
          :items="casesGroupData"
          hover
        >
          <template #cell(actions)="data">
            <feather-icon
              v-if="$ability.can(constants.action.permissionEditCaseGroup, constants.resource.caseGroups)"
              v-b-modal.create-case-modal
              icon="EyeIcon"
              @click="editCaseGroup(data.item)"
            />
            <feather-icon
              v-if="$ability.can(constants.action.permissionDeleteCaseGroup, constants.resource.caseGroups) && user_type !== 'super-admin'"
              icon="Trash2Icon"
              style="margin-left: 15px; color: #ff3737;"
              @click="deleteCaseGroup(data.item.id)"
            />
          </template>
          <template #cell(prefix)="data">
            {{ data.item.prefix ? data.item.prefix : 'N/A' }}
          </template>
          <template #cell(starting_process)="data">
            {{ data.item.process.title }}
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">{{ $t('DEBTIA_SHOWING') }} {{ from }} to {{ to }} of {{ totalPages }} {{ $t('DEBTIA_ENTRIES') }}</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >

              <b-pagination
                v-model="currentPage"
                :total-rows="totalPages"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>

            </b-col>

          </b-row>
        </div>
        <case-group-modal
          ref="create-case-modal"
          :group-data="editData"
          :modal-loads="modalLoader"
          :reload-method="getCaseGroups"
          :processes-options="processesoptions"
          :standard-process="standardProcess"
        />
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import {
  BCard, BOverlay, BTable, BRow, BCol, BFormInput, BButton, BPagination,
} from 'bootstrap-vue'
import axios from '@axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import vSelect from 'vue-select'
import constants from '@/app-configs/constants'
import i18n from '@/libs/i18n'
import Ripple from 'vue-ripple-directive'
import CaseGroupModal from './CaseGroupModal.vue'

export default {
  components: {
    BCard,
    BOverlay,
    BTable,
    BRow,
    BCol,
    vSelect,
    BFormInput,
    BButton,
    BPagination,
    CaseGroupModal,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      loader: false,
      casesGroupData: [],
      perPage: 10,
      perPageOptions: [10, 25, 50, 100],
      searchQuery: '',
      totalPages: 0,
      from: 0,
      to: 0,
      currentPage: 1,
      editData: {},
      addCaseInput: {
        id: 0,
        title: '',
        prefix: '',
        starting_process_id: 0,
        sender_email: '',
        description: '',
        sendgrid_key: '',
        mail_from_address: '',
        mail_from_name: '',
        user_id: JSON.parse(localStorage.getItem('userData')).data.id,
      },
      caseId: 0,
      user_type: JSON.parse(localStorage.getItem('userData')).data.user_type,
      modalLoader: true,
      constants,
      isSuperAdmin: false,
      showVariables: false,
      busy: false,
      clicked: false,
      searchRun: false,
      selected: [],
      processesoptions: [],
      standardProcess: 0,
    }
  },
  computed: {
    tableFields() {
      let fields = []
      fields = [
        { key: 'id', sortable: true },
        { key: 'title', sortable: true, label: i18n.t('DEBTIA_GROUP_TITLE') },
        { key: 'prefix', sortable: true, label: i18n.t('DEBTIA_PREFIX') },
        { key: 'starting_process', label: i18n.t('DEBTIA_GROUP_STARTING_PROCESS') },
        { key: 'actions', label: i18n.t('DEBTIA_ACTION') },
        // { key: 'action', label: i18n.t('DEBTIA_ACTION') },
      ]
      return fields
    },
  },
  watch: {
    searchQuery: {
      handler() {
        if (!this.searchQuery) this.getCaseGroups()
      },
    },
    currentPage: {
      handler() {
        this.getCaseGroups()
      },
    },
    perPage: {
      handler() {
        this.currentPage = 1
        this.getCaseGroups()
      },
    },
  },
  created() {
    this.getCaseGroups()
    this.getProcesses()
  },
  methods: {
    async getProcesses() {
      const processes = await axios.get('/process/list?perPage=10000')
      if (processes.status) {
        const currentProcesses = processes.data.data.processes.data
        currentProcesses.forEach(element => {
          const elementObj = { label: element.title, value: element.id }
          this.processesoptions.push(elementObj)
        })
        this.addCaseInput.starting_process_id = currentProcesses[currentProcesses.length - 1].id
        this.standardProcess = this.processesoptions[this.processesoptions.length - 1].value
      }
    },
    async getCaseGroups() {
      this.loader = true
      const groups = await axios.get(`/list-debt-case-groups?perPage=${this.perPage}&q=${this.searchQuery}&page=${this.currentPage}&sortDesc=true`)
      if (groups.status) {
        this.casesGroupData = groups.data.data.case_groups.data
        this.totalPages = groups.data.data.case_groups.total
        this.from = groups.data.data.case_groups.from
        this.to = groups.data.data.case_groups.to
        this.currentPage = groups.data.data.case_groups.current_page
        this.loader = false
      }
    },
    editCaseGroup(item) {
      const inputData = {
        id: item.id,
        title: item.title,
        prefix: item.prefix,
        starting_process_id: item.starting_process_id,
        sender_email: item.sender_email,
        description: item.description,
        sendgrid_key: item.sendgrid_key,
        mail_from_name: item.mail_from_name,
        mail_config_id: item.mail_config_id,
        user_id: JSON.parse(localStorage.getItem('userData')).data.id,
      }
      this.editData = inputData
    },
    addCaseGroup(item) {
      this.modalLoader = true
      this.editData = item
      this.modalLoader = false
    },
    async deleteCaseGroup(id) {
      this.loader = true
      const caseGroup = await axios.post('/delete-debt-case-group',
        { id })
      if (caseGroup.status) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: i18n.t('DEBTIA_SUCCESS'),
            icon: 'CoffeeIcon',
            variant: 'primary',
            text: i18n.t('DEBTIA_CASE_GROUP_DELETED_MSG'),
          },
        })
        this.getCaseGroups()
      }
    },
    // actionColumn() {
    //   if (this.$ability.cannot(this.constants.action.permissionLetterTemplateEdit, this.constants.resource.letterTemplate) && this.$ability.cannot(this.constants.action.permissionLetterTemplateDelete, this.constants.resource.letterTemplate)) {
    //     if (this.user_type !== 'super-admin') {
    //       this.tableFields.splice(2, 1)
    //     } else {
    //       this.tableFields.splice(3, 1)
    //     }
    //   }
    // },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.search_by_select .vs__dropdown-toggle{
  width: 160px;
}
</style>
